<!-- =========================================================================================
  File Name: DeviceDetailDialog.vue
  Description: View Detail - Dialog component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/DashboardDeviceTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-nested-dialog" :title="$t('DetailDevice')" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list no-footer" :settings="settings">
			<div class="p-6">
				<!-- Image Container -->
				<div v-if="device.imageSource" class="img-container w-64 mx-auto flex items-center justify-center mb-6">
					<img :src="device.imageSource" alt="img" class="responsive" />
				</div>
				<vs-row class="mb-2">
					<vs-col vs-w="2" vs-xs="5">
						<label for>{{ $t("DeviceName") }}:</label>
					</vs-col>
					<vs-col vs-w="10" vs-xs="7" class="text-black">{{ device.name }}</vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="2" vs-xs="5">
						<label for>{{ $t("DeviceCode") }}:</label>
					</vs-col>
					<vs-col vs-w="10" vs-xs="7" class="text-black">{{ device.code }}</vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="2" vs-xs="5">
						<label for>{{ $t("DeviceManager") }}:</label>
					</vs-col>
					<vs-col vs-w="10" vs-xs="7" class="text-black">{{ device.managerName }}</vs-col>
				</vs-row>
				<div class="list-sensors mb-2" v-if="device.sensorData && device.sensorData.length">
					<label>{{ $t("DeviceSensorData") }}:</label>
					<ul class="pl-3 sm:pl-6">
						<li v-for="(data, index) in device.sensorData" :key="index" class="mb-2 last:mb-0 sm:mb-0">
							<div v-if="data.isActive" :class="[{ 'text-solid-green-1': !data.isOverLimit, 'text-solid-red': data.isOverLimit }, 'sensor-value flex flex-col sm:flex-row']">
								<span class="sensor-value__accessory-name text-black uppercase-first-letter" v-if="data.accessoryName">{{ data.accessoryName }}:&nbsp;</span>
								<span class="whitespace-no-wrap sensor-value__current font-bold">{{ data.value }} {{ $t(data.unit) | lowerCaseFirstLetter }}&nbsp;</span>
								<div class="sensor-value__limit text-black sm:ml-1" v-if="data.alertThreshold || data.warningThreshold">
									(<template v-if="data.warningThreshold">{{ `${$t("Warning")}: ${data.warningThreshold}` }} {{ $t(data.unit) | lowerCaseFirstLetter }}</template>
									<template v-if="data.warningThreshold && data.alertThreshold">;&nbsp;</template>
									<template v-if="data.alertThreshold">{{ `${$t("Alert")}: ${data.alertThreshold}` }} {{ $t(data.unit) | lowerCaseFirstLetter }}</template
									>)
								</div>
							</div>
						</li>
					</ul>
				</div>
				<vs-row class="mb-2">
					<vs-col vs-w="2" vs-xs="5">
						<label for>{{ $t("DeviceStatus") }}:</label>
					</vs-col>
					<vs-col vs-w="10" vs-xs="7" class="font-bold" :style="{ color: device.statusColor }">{{ device.statusName }}</vs-col>
				</vs-row>
			</div>
		</PerfectScrollbar>
	</el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		},
		dataId: {
			type: [String, Number],
			required: true
		}
	},
	watch: {
		isDialogActive(val) {
			if (!val) return;
		}
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		...mapGetters({
			getDevice: "dashboardManagement/getDevice"
		}),
		device() {
			return this.getDevice(this.dataId) || {};
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-nested-dialog {
	::v-deep .el-dialog {
		max-height: 435px;
	}

	img {
		max-height: 180px;
	}

	.list-sensors {
		.sensor-value {
			&::before {
				content: "-";
				margin-right: 5px;
				color: var(--color-black);
			}

			@media only screen and (max-width: 576px) {
				&::before {
					display: none;
				}

				.sensor-value__accessory-name::before {
					content: "*";
					margin-right: 5px;
					color: var(--color-black);
				}

				.sensor-value__current::before,
				.sensor-value__limit::before {
					content: "-";
					font-weight: normal;
					margin-right: 5px;
					color: var(--color-black);
				}
			}
		}
	}
}
</style>
